import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'humanize'
})
export class HumanizePipe implements PipeTransform {
  transform(value: string, args?: any): any {
    return _.lowerCase(value).split(' ').map(word => _.upperFirst(word)).join(' ');
  }
}
